var makeBuiltIn = {exports: {}};

export { makeBuiltIn as __module };
